// sagas/employeeSaga.js
import { call, put, takeLatest } from "redux-saga/effects";
import {
  FETCH_EMPLOYEES_FAILURE,
  FETCH_EMPLOYEES_REQUEST,
  FETCH_EMPLOYEES_SUCCESS,
  RESEND_ACTIVATION_REQUEST,
  RESEND_ACTIVATION_SUCCESS,
  RESEND_ACTIVATION_FAILURE,
} from "../Actions/Actions";
import AuthHandler from "../../utils/AuthHandler";
import Axios from "../../utils/Axios";
import { FETCH_EMPLOYEES_LIST } from "../../config/API_Collection";
import { getErrorMessage } from "../../config/Error_Codes";




function* fetchEmployeesWorker(action) {
  try {
    const response = yield call(Axios.get, FETCH_EMPLOYEES_LIST);

    console.log('Employee API Response:', response);
    console.log('Response data:', response?.data);
    
    if (response.status === 200) {
      // Check if response contains an error message instead of data
      if (response?.data?.error) {
        // API returned error in 200 response (e.g., "No employees Found")
        console.log('No employees found, dispatching empty array');
        yield put({type:FETCH_EMPLOYEES_SUCCESS,payload:[]});
      } else {
        // Normal success with data
        const employeeData = response?.data?.data || [];
        console.log('Employees found:', employeeData.length);
        yield put({type:FETCH_EMPLOYEES_SUCCESS,payload:employeeData});
      }
    }
  } catch (error) {
    console.error('Error fetching employees:', error);
    const status = error.response?.status || error.status;
    const errorMsg = status === 404 
      ? 'No employees found' 
      : (error.response?.data?.message || getErrorMessage(status) || 'Failed to fetch employees');
    
    // Dispatch failure to stop loading state
    yield put({type:FETCH_EMPLOYEES_FAILURE,payload:errorMsg});
  }
}

export default function* employeesSaga() {
  yield takeLatest(FETCH_EMPLOYEES_REQUEST, fetchEmployeesWorker);
  yield takeLatest(RESEND_ACTIVATION_REQUEST, resendActivationWorker);
}

function* resendActivationWorker(action) {
  try {
    const payload = action.payload || {};
    // backend expects /employees/resend_email with { employee_id }
    const response = yield call(Axios.post, "/employees/resend_email", payload);
    if (response?.status === 200) {
      yield put({ type: RESEND_ACTIVATION_SUCCESS, payload: response.data?.message || "Activation email resent" });
    } else {
      yield put({ type: RESEND_ACTIVATION_FAILURE, payload: response?.data?.message || "Failed to resend activation" });
    }
  } catch (error) {
    yield call(AuthHandler, error.response?.status);
    const msg = (error?.response?.data && error.response.data.message) || error.message || "Failed to resend activation";
    yield put({ type: RESEND_ACTIVATION_FAILURE, payload: msg });
  }
}
